module.exports = __webpack_public_path__ + "img/bg.e33ed6b9.webp";